import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PageHeaderPrimary } from 'cat-ecommerce-alloy';
import ContactUsOptions from '../ContactUsOptions';
import { useSelector } from 'react-redux';

const WarrantyModalContent = ({ orderId = '', openDealerLocator }) => {
  const [t] = useTranslation();
  const isCatCSR = useSelector(s => s.common?.isCatCSR);

  return (
    <div className="mt-3">
      <PageHeaderPrimary title={t('WARRANTY_INFO')} />
      <p className="u-fs--16 u-color--DarkGray my-4">
        {t('WARRANTY_STATEMENT')}
      </p>
      <ContactUsOptions
        orderId={orderId}
        isCSR={isCatCSR}
        openDealerLocator={openDealerLocator}
      />
    </div>
  );
};

export default WarrantyModalContent;

WarrantyModalContent.propTypes = {
  orderId: PropTypes.string,
  openDealerLocator: PropTypes.func
};
